export default "__VITE_ASSET__BQiPSpUO__"